import { ManageDiaryModule } from './manage-diary/manage-diary.module';
import { OrganizationSetupModule } from './organization-setup/organization-setup.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { LoginComponent } from './login/login.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from './loader/loader.service';
import { LoaderInterceptorService } from './loader/loader-interceptor.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { MydiaryComponent } from './mydiary/mydiary.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { ManageProfileComponent } from './manage-profile/manage-profile.component';
import { NgbDateCustomParserFormatter } from './common/date-parser.service';
import { MasterDataModule } from './master-data/master-data.module';
import { OrganizationSetupService } from './services/organization-setup.service';
import { HumanResourceModule } from './human-resource/human-resource.module';
import { UserDetailsModule } from './user-details/user-details.module';
import { DiaryDetailsComponent } from './hr-report/diary-details/diary-details.component';
import { ExperienceSummaryComponent } from './hr-report/experience-summary/experience-summary.component';
import { MyDiariesComponent } from './standard-reports/my-diaries/my-diaries.component';
import { MyLeavesDetailsComponent } from './standard-reports/my-leaves-details/my-leaves-details.component';
import { EmpLeaveSummaryComponent } from './hr-report/emp-leave-summary/emp-leave-summary.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { IndependenceDecrelationComponent } from './independence-decrelation/independence-decrelation.component';
import { IndependenceQuestionComponent } from './independence-decrelation/independence-question/independence-question.component';
import { SalaryComponent } from './account-report/salary/salary.component';
import { StipendComponent } from './account-report/stipend/stipend.component';
import { PenaltySummaryComponent } from './hr-report/penalty-summary/penalty-summary.component';
import { AnnualComponent } from './analytic-report/independence/annual/annual.component';
import { ClientIndependenceComponent } from './analytic-report/independence/client/client.component';
import { AllClientComponent } from './analytic-report/independence/all-client/all-client.component';
import { EmployeeComponent } from './analytic-report/independence/employee/employee.component';
import { BudgetComponent } from './analytic-report/budget/budget.component';
import { MyAllClientComponent } from './hr-report/independence/my-all-client/my-all-client.component';
import { MyAnnualComponent } from './hr-report/independence/my-annual/my-annual.component';
import { MyClientComponent } from './hr-report/independence/my-client/my-client.component';
import { MyEmployeeComponent } from './hr-report/independence/my-employee/my-employee.component';
import { MyPenaltySummaryComponent } from './standard-reports/my-penalty-summary/my-penalty-summary.component';
import { ArticleOneSixthReportComponent } from './hr-report/article-one-sixth-report/article-one-sixth-report.component';
import { MySalaryClosingComponent } from './standard-reports/my-salary-closing/my-salary-closing.component';
import { MyArticleOneSixthReportComponent } from './standard-reports/my-article-one-sixth-report/my-article-one-sixth-report.component';
import { EmpanelmentReportComponent } from './hr-report/empanelment-report/empanelment-report.component';
import { ClientConveyanceSummaryComponent } from './account-report/client-conveyance-summary/client-conveyance-summary.component';
import { ClientConveyanceAssignmentComponent } from './account-report/client-conveyance-assignment/client-conveyance-assignment.component';
import { MyStipendReportComponent } from './standard-reports/my-stipend-report/my-stipend-report.component';
import { MonthlyConveyanceReportComponent } from './account-report/monthly-conveyance-report/monthly-conveyance-report.component';
import { MonthlyConveyanceDetailReportComponent } from './account-report/monthly-conveyance-detail-report/monthly-conveyance-detail-report.component';
import { OvertimeReportComponent } from './hr-report/overtime-report/overtime-report.component';
import { ArticleAvailabilityReportComponent } from './hr-report/article-availability-report/article-availability-report.component';
import { AuthGuard } from './guard/auth.guard';
import { AuthService } from './services/auth.service';
import { DocumentManagementComponent } from './document-management-details/document-management/document-management.component';
import { DocumentListComponent } from './document-management-details/document-list/document-list.component';
import { DocumentFolderMenuComponent } from './document-management-details/document-folder-menu/document-folder-menu.component';
import { CreateFolderComponent } from './document-management-details/create-folder/create-folder.component';
import { TravelSheetComponent } from './travel-sheet/travel-sheet/travel-sheet.component';
import { MyPendingTravelSheetApprovalsComponent } from './travel-sheet/my-pending-travel-sheet-approvals/my-pending-travel-sheet-approvals.component';
import { SubmittedSheetsComponent } from './travel-sheet/submitted-sheets/submitted-sheets.component';
import { MyUnapprovedTravelSheetsComponent } from './travel-sheet/my-unapproved-travel-sheets/my-unapproved-travel-sheets.component';
import { BudgetVsActualCostReportComponent } from './analytic-report/budget-vs-actual-cost-report/budget-vs-actual-cost-report.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BankPaymentReportComponent } from './account-report/bank-payment-report/bank-payment-report.component';
import { SalarySlipReportComponent } from './account-report/salary-slip-report/salary-slip-report.component';
import { ArticleDebitCreditHoursComponent } from './hr-report/article-debit-credit-hours/article-debit-credit-hours.component';
import { MyAllIndependenceDeclarationComponent } from './hr-report/independence/my-all-independence-declaration/my-all-independence-declaration.component';
import { AnnualSalaryReportComponent } from './account-report/annual-salary-report/annual-salary-report.component';
import { ExitFormComponent } from './user-details/exit-form/exit-form.component';
import { ExitFormSummaryComponent } from './user-details/exit-form-summary/exit-form-summary.component';
import { AnnualStipendReportComponent } from './account-report/annual-stipend-report/annual-stipend-report.component';
import { ExpenseReimbursementReportComponent } from './account-report/expense-reimbursement-report/expense-reimbursement-report.component';
import { MyActualTaskReportComponent } from './analytic-report/my-actual-task-report/my-actual-task-report.component';
import { SoftwareAssetsComponent } from './asset-management/software-assets/software-assets.component';
import { HardwareAssetsComponent } from './asset-management/hardware-assets/hardware-assets.component';
import { AssetsPhysicalVerificationReportComponent } from './account-report/assets-physical-verification-report/assets-physical-verification-report.component';
import { AssetsPopupConfirmationReportComponent } from './account-report/assets-popup-confirmation-report/assets-popup-confirmation-report.component';
import { AssetsTransferHistoryReportComponent } from './account-report/assets-transfer-history-report/assets-transfer-history-report.component';
import { PopUpConfirmationComponent } from './asset-management/pop-up-confirmation/pop-up-confirmation.component';
import { UpdateBudgetComponent } from './analytic-report/update-budget/update-budget.component';
import { VarianceReportExcelComponent } from './analytic-report/variance-report-excel/variance-report-excel.component';
import { AssetTermsOfUsesComponent } from './dashboard/asset-terms-of-uses/asset-terms-of-uses.component';
import { KnowYourColleaugesComponent } from './user-details/know-your-colleauges/know-your-colleauges.component';
import { KnowYourClientsComponent } from './user-details/know-your-clients/know-your-clients.component';
import { MyHolidaysComponent } from './user-details/my-holidays/my-holidays.component';
import { UnsafeDocumentPipe } from './document-management-details/unsafe-document.pipe';
import { MainDashboardComponent } from './dashboard/main-dashboard/main-dashboard.component';
import { AllPartnersDashboardComponent } from './dashboard/all-partners-dashboard-managing-partner/all-partners-dashboard/all-partners-dashboard.component';
import { ArticleVacancyComponent } from './master-data/article-vacancy/article-vacancy.component';
import { ReportListComponent } from './report-list/report-list.component';
import { MyTargetReportComponent } from './analytic-report/my-target-report/my-target-report.component';
import { UserDataListComponent } from './user-data-list/user-data-list.component';
import { MyReportListComponent } from './my-report-list/my-report-list.component';
import { MasterDataListComponent } from './master-data-list/master-data-list.component';
import { AccountReportListComponent } from './account-report-list/account-report-list.component';
import { HrReportListComponent } from './hr-report-list/hr-report-list.component';
import { MonthlyNewJoineeReportComponent } from './hr-report/monthly-new-joinee-report/monthly-new-joinee-report.component';
import { MonthlyLeftEmpReportComponent } from './hr-report/monthly-left-emp-report/monthly-left-emp-report.component';
import { TestComponent } from './test/test.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DiaryDetailsClientWiseComponent } from './hr-report/diary-details-client-wise/diary-details-client-wise.component';
import { MisReportComponent } from './hr-report/mis-report/mis-report.component';
import { MyPipesModule } from "./common/my-pipes.module";
import { VersionCheckInterceptor } from './common/versionCheckInterceptor.interceptor';
import { ProbationCompleteReportComponent } from './hr-report/probation-complete-report/probation-complete-report.component';
import { ArticleshipEndReportComponent } from './hr-report/articleship-end-report/articleship-end-report.component';
import { ConsultantsEndReportComponent } from './hr-report/consultants-end-report/consultants-end-report.component';
import { WorkAnniversaeyReportComponent } from './hr-report/work-anniversaey-report/work-anniversaey-report.component';
import { IncompleteProfilesComponent } from './hr-report/incomplete-profiles/incomplete-profiles.component';
import { ITReportListComponent } from './IT-report-list/it-report-list/it-report-list.component';
import { CtcDetailsReportComponent } from './hr-report/ctc-details-report/ctc-details-report.component';
import { MyDpdpDeclarationComponent } from './hr-report/independence/my-dpdp-declaration/my-dpdp-declaration.component';
import { DpdpDeclarationComponent } from './analytic-report/independence/dpdp-declaration/dpdp-declaration.component';
import { AccessPrivilegeComponent } from './access-privilege/access-privilege.component';
import { PartnerReportListComponent } from './partner-report-list/partner-report-list.component';
import { LatestCtcDetailsReportComponent } from './hr-report/latest-ctc-details-report/latest-ctc-details-report.component';
import { LatestReportingPartnersReportComponent } from './hr-report/latest-reporting-partners-report/latest-reporting-partners-report.component';
import { PendingDiaryWeeksTeamComponent } from './manage-diary/pending-diary-weeks-team/pending-diary-weeks-team/pending-diary-weeks-team.component';

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        HeaderComponent,
        SidebarComponent,
        LoginComponent,
        LoaderComponent,
        MydiaryComponent,
        UnderConstructionComponent,
        ManageProfileComponent,
        DiaryDetailsComponent,
        ExperienceSummaryComponent,
        MyDiariesComponent,
        MyLeavesDetailsComponent,
        EmpLeaveSummaryComponent,
        IndependenceDecrelationComponent,
        IndependenceQuestionComponent,
        SalaryComponent,
        StipendComponent,
        PenaltySummaryComponent,
        AnnualComponent,
        ClientIndependenceComponent,
        AllClientComponent,
        EmployeeComponent,
        BudgetComponent,
        MyAllClientComponent,
        MyAnnualComponent,
        MyClientComponent,
        MyEmployeeComponent,
        MyPenaltySummaryComponent,
        ArticleOneSixthReportComponent,
        MySalaryClosingComponent,
        MyArticleOneSixthReportComponent,
        EmpanelmentReportComponent,
        ClientConveyanceSummaryComponent,
        ClientConveyanceAssignmentComponent,
        MyStipendReportComponent,
        MonthlyConveyanceReportComponent,
        MonthlyConveyanceDetailReportComponent,
        OvertimeReportComponent,
        ArticleAvailabilityReportComponent,
        DocumentManagementComponent,
        DocumentListComponent,
        DocumentFolderMenuComponent,
        CreateFolderComponent,
        TravelSheetComponent,
        MyPendingTravelSheetApprovalsComponent,
        SubmittedSheetsComponent,
        MyUnapprovedTravelSheetsComponent,
        BudgetVsActualCostReportComponent,
        BankPaymentReportComponent,
        MyAllIndependenceDeclarationComponent,
        AnnualSalaryReportComponent,
        SalarySlipReportComponent,
        ArticleDebitCreditHoursComponent,
        MyAllIndependenceDeclarationComponent,
        ExitFormComponent,
        ExitFormSummaryComponent,
        AnnualStipendReportComponent,
        ExpenseReimbursementReportComponent,
        MyActualTaskReportComponent,
        SoftwareAssetsComponent,
        HardwareAssetsComponent,
        AssetsPhysicalVerificationReportComponent,
        AssetsPopupConfirmationReportComponent,
        AssetsTransferHistoryReportComponent,
        PopUpConfirmationComponent,
        UpdateBudgetComponent,
        VarianceReportExcelComponent,
        AssetTermsOfUsesComponent,
        KnowYourColleaugesComponent,
        KnowYourClientsComponent,
        MyHolidaysComponent,
        UnsafeDocumentPipe,
        MainDashboardComponent,
        ArticleVacancyComponent,
        ReportListComponent,
        MyTargetReportComponent,
        UserDataListComponent,
        MyReportListComponent,
        MasterDataListComponent,
        AccountReportListComponent,
        HrReportListComponent,
        MonthlyNewJoineeReportComponent,
        MonthlyLeftEmpReportComponent,
        DiaryDetailsClientWiseComponent,
        MisReportComponent,
        TestComponent,
        AllPartnersDashboardComponent,
        ProbationCompleteReportComponent,
        ArticleshipEndReportComponent,
        ConsultantsEndReportComponent,
        WorkAnniversaeyReportComponent,
        IncompleteProfilesComponent,
        ITReportListComponent,
        CtcDetailsReportComponent,
        MyDpdpDeclarationComponent,
        DpdpDeclarationComponent,
        AccessPrivilegeComponent,
        PartnerReportListComponent,
        LatestCtcDetailsReportComponent,
        LatestReportingPartnersReportComponent,
        PendingDiaryWeeksTeamComponent
    ],
    providers: [
        LoaderService,
        AuthService,
        AuthGuard,
        OrganizationSetupService,
        [
            // {
            //     provide: HTTP_INTERCEPTORS,
            //     useClass: VersionCheckInterceptor,
            //     multi: true,
            // },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptorService,
            
            multi: true,
        }
       
    ],
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        NgxPaginationModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
        HttpClientModule,
        BrowserAnimationsModule,
        MasterDataModule,
        OrganizationSetupModule,
        HumanResourceModule,
        ManageDiaryModule,
        UserDetailsModule,
        AppRoutingModule,
        ToastrModule.forRoot(),
        NgxChartsModule,
        AngularEditorModule,
        MyPipesModule
    ]
})
export class AppModule { }
